import React, { useState, useEffect, useRef } from "react";
import uploadIcon from "../../assets/images/upload-icon.png";
import searchIcon from "../../assets/images/search-icon.png";
import uploadIconB from "../../assets/images/upload-icon1.png";
import FolderDialog from "./FolderDialog";
import FolderList from "./folderListing";
import { useDispatch } from "react-redux";
import AddFolderContent from "./AddFolderContent";
import UploadFileContent from "./UploadFileContent";
import { getRepository, searchRepository } from "../../redux/slices/apiSlice";
import { useSelector } from "react-redux";
import useAuth from "../../hooks/useAuth";
import UploadMultipleFiles from "./UploadMultipleFiles";
import { addFolderRoles } from "../../utils";
import CanAccess from "../../utils/CanAccess";
import moment from "moment";



const AddFileContent = ({ onClose }) => {
  return (
    <div className="formBox">
      <div className="form-group">
        <label>Tags</label>
        <input
          className="form-control"
          type="text"
          placeholder="Tags"
          value=""
        />
      </div>
      <div class="form-group !mb-0">
        <button class="blueBtn">Save</button>
      </div>
    </div>
  );
};

const Repository = () => {
  const [folders, setFolders] = useState([]);
  const [selectedFolderId, setSelectedFolderId] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [currentFolder, setCurrentFolder] = useState("Folders");
  const divRef = useRef(null);
  const dispatch = useDispatch();
  const { repositoryList } = useSelector((state) => state.api);
  const [currentParentId, setCurrentParentId] = useState(null);
  const [rootParentObj, setRootParentObj] = useState(null);
  const { isLoggedin, user } = useAuth();
  const [openAddBtnDialog, setOpenAddBtnDialog] = useState(false);
  const [openUploadBtnDialog, setOpenUploadBtnDialog] = useState(false);
  const [openUploadMultipleBtnDialog, setOpenUploadMultipleBtnDialog] =
    useState(false);
  const [openAddEditDialog, setOpenAddEditDialog] = useState(false);
  const [openRenameBtnDialog, setOpenRenameBtnDialog] = useState(false);
  const [isCommonFolder, setIsCommonFolder] = useState(false);
  const [isSearched, setIsSearched] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedTerm, setDebouncedTerm] = useState("");
  const [isChildFolder, setIsChildFolder] = useState(true);
  const token = sessionStorage.getItem("token");
  const [yearOptions, setYearOptions] = useState([moment().year() - 1, moment().year(), moment().year() + 1]);


  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedTerm(searchTerm);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchTerm]);

  useEffect(() => {
    isSearched && (debouncedTerm.length < 1 || debouncedTerm.length >= 2) && fetchSearchResults(debouncedTerm);
  }, [debouncedTerm]);

  const fetchSearchResults = async (query) => {
    const headers = {
      accept: "application/json",
      authorization: token,
    };
    dispatch(getRepository({ payload: { id: currentParentId || "", search: query }, headers })); // , user_id: user?._id

    // await dispatch(searchRepository({ payload: query, headers }));
  };
  const fetchFolders = async (parentId) => {
    try {
      const headers = {
        Accept: "application/json",
        Authorization: token,
      };
      dispatch(getRepository({ payload: { id: parentId || "" }, headers })); // , user_id: user?._id
    } catch (error) {
      console.error("Error fetching folders:", error);
    }
  };

  useEffect(() => {
    fetchFolders(null);
  }, []);

  useEffect(() => {
    if (repositoryList?.minDate && repositoryList?.maxDate) {
      const min = repositoryList?.minDate;
      const max = repositoryList?.maxDate;
      const options = [];
      for (let year = min; year <= max; year++) {
        options.push(year);
      }
      setYearOptions(options);
    }
    setFolders(repositoryList);
    setIsChildFolder(repositoryList?.result?.[0]?.folderType != "root_folder");
  }, [repositoryList]);

  const resetFolders = () => {
    fetchFolders(null);
  };
  useEffect(() => {
    currentParentId && fetchFolders(currentParentId);
    setSearchTerm("");
  }, [currentParentId]);

  const handleFolderClick = (folderId) => {
    if (selectedFolderId === folderId) {
      fetchFolders(folderId);
    } else {
      setSelectedFolderId(folderId);
      fetchFolders(folderId);
    }
  };

  // Function to toggle visibility
  const toggleDiv = (event) => {
    event.stopPropagation(); // Prevent event bubbling
    setIsVisible((prev) => !prev);
  };

  // Hide div when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setIsVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const [isUploadVisible, setIsUploadVisible] = useState(false);

  const toggleUpload = (event) => {
    event.stopPropagation(); // Prevents closing when clicking inside the menu
    setIsUploadVisible((prev) => !prev);
  };

  // Hide upload menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setIsUploadVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="serachField">
        <div className="searchFilter">
          <div class="form-group">
            <input
              className="form-control"
              // type="search"
              placeholder="Search file here..."
              value={searchTerm}
              onChange={(e) => { setIsSearched(true); setSearchTerm(e.target.value); }}
            />
            <span id="btn-search" class="searchIcon">
              <img src={searchIcon} alt="Search" class="img-fluid deskDiv" />
            </span>
          </div>
          {/* <div className="filterBtn">
            <a id="btn-filter">
              <img src={filterIcon} alt="Search" class="img-fluid deskDiv" />{" "}
              Filter
            </a>
          </div> */}
        </div>
        {currentParentId && isChildFolder && (
          <CanAccess allowedRoles={[...addFolderRoles]} currentFolder={currentFolder} isFileUploadBtn={true}>
            <div className="upload">
              <a class="blueBtn" onClick={toggleUpload}>
                <span>
                  <img src={uploadIcon} alt="Upload" />
                </span>
                Upload
              </a>
              {isUploadVisible && (
                <ul
                  ref={divRef}
                  className="more-opt"
                  onClick={(e) => e.stopPropagation()}
                >
                  <li onClick={() => setOpenUploadBtnDialog(true)}>
                    <span>
                      <img src={uploadIconB} alt="" />
                    </span>{" "}
                    Upload File
                  </li>
                  <li onClick={() => setOpenUploadMultipleBtnDialog(true)}>
                    <span>
                      <img src={uploadIconB} alt="" />
                    </span>{" "}
                    Upload Multiple File
                  </li>
                </ul>
              )}
            </div>
          </CanAccess>
        )}
      </div>
      <div className="repositorySection">
        {/* <h5 className="">{currentFolderName}</h5> */}

        <ul className="repositoryList">
          <FolderList
            setCurrentFolder={setCurrentFolder}
            setOpenAddBtnDialog={setOpenAddBtnDialog}
            resetFolders={resetFolders}
            folderList={folders}
            currentParentId={currentParentId}
            setCurrentParentId={setCurrentParentId}
            fetchFolders={fetchFolders}
            setRootParentObj={setRootParentObj}
            rootParentObj={rootParentObj}
            isCommonFolder={isCommonFolder}
            setIsCommonFolder={setIsCommonFolder}
            isChildFolder={isChildFolder}
            yearOptions={yearOptions}
          />
        </ul>
      </div>
      <FolderDialog
        isOpen={openAddBtnDialog}
        onClose={() => setOpenAddBtnDialog(false)}
        title={"Add Folder"}
        content={
          <AddFolderContent
            onClose={() => setOpenAddBtnDialog(false)}
            currentParentId={currentParentId}
            fetchFolders={fetchFolders}
            openAddBtnDialog={openAddBtnDialog}
            folderList={folders}
            rootParentObj={rootParentObj}
            isCommonFolder={isCommonFolder}
          />
        }
      />
      <FolderDialog
        isOpen={openUploadBtnDialog}
        onClose={() => setOpenUploadBtnDialog(false)}
        title={"Upload File"}
        content={
          <UploadFileContent
            onClose={() => setOpenUploadBtnDialog(false)}
            currentParentId={currentParentId}
            fetchFolders={fetchFolders}
            openUploadBtnDialog={openUploadBtnDialog}
            folderList={folders}
          />
        }
      />
      <FolderDialog
        isOpen={openUploadMultipleBtnDialog}
        onClose={() => setOpenUploadMultipleBtnDialog(false)}
        title={"Upload Multiple Files"}
        content={
          <UploadMultipleFiles
            onClose={() => setOpenUploadMultipleBtnDialog(false)}
            currentParentId={currentParentId}
            fetchFolders={fetchFolders}
            openUploadMultipleBtnDialog={openUploadMultipleBtnDialog}
          />
        }
      />

      <FolderDialog
        isOpen={openAddEditDialog}
        onClose={() => setOpenAddEditDialog(false)}
        title={"Add/Edit Tags"}
        content={<AddFileContent onClose={() => setOpenAddEditDialog(false)} />}
      />
    </>
  );
};

export default Repository;
